const taskTemplates = require('../../task-templates');

const tasksData = [
	/* Case 1 */
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 1,
		taskId: 'subjects-hf-duration',
		title: 'Opgave 1A',
		text: `Hvor mange år tager en HF?`,
		hintText: `I kan nemt finde svaret her: 
			<br /><br />https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/hf-eksamen-hf`,
		popupText: `Det er netop her, HF skiller sig ud fra STX, da den tager et år mindre.`,
		answer: 2,
		unit: 'år',
		image: 'subjects-hf'
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 2,
		taskId: 'subjects-sort-required',
		lockedById: 'subjects-hf-duration',
		title: 'Opgave 1B',
		text: `I kan nemt finde svaret her: 
			<br /><br />https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/hf-eksamen-hf`,
		hintText: `Overvej at tjekke UddannelsesGuiden på nettet.`,
		popupText: `Obligatoriske fag er dem, alle skal have - de sikrer, at alle elever får de samme grundkompetencer.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'required', 
				title: `Obligatoriske fag`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'notRequired', 
				title: `Ikke-obligatoriske fag:`
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1, text: `Dansk A`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2, text: `Engelsk B`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3, text: `Historie B`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 4, text: `Matematik C`, categoryIds: ['required']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 5, text: `Matematik B`, categoryIds: ['notRequired']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 6, text: `Engelsk A`, categoryIds: ['notRequired']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 7, text: `Kemi B`, categoryIds: ['notRequired']
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 3,
		title: 'Opgave 1C',
		taskId: 'subjects-mc-multiple-a-levels',
		lockedById: 'subjects-sort-required',
		text: `På HF skal mindst ét fag være på A-niveau, men er uddannelsen stadig en fuld gymnasial eksamen?`,
		hintText: `I kan nemt finde svaret her: 
			<br /><br />https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/hf-eksamen-hf`,
		popupText: `Et A-niveaufag giver mulighed for at søge videregående uddannelser, derfor skal alle have mindst ét.`,
		image: 'classroom-students',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'JA', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'NEJ'
			}),
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 1,
		title: 'Opgave 1A',
		taskId: 'subjects-hf-stands-for',
		text: `Hvad står bogstaverne HF for?`,
		hintText: 'Det kan googles ret hurtigt.',
		popupText: `Navnet afspejler, at uddannelsen er en forberedelse til videre studier efter folkeskolen.`,
		image: 'hf-hat',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: `Højere Forberedelseseksamen`, isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: `Højere Færdighedseksamen`
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: `Højere Forberedelsesuddannelse`
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: `Højere Faglighedseksamen`
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5, text: `Højere Forskningseksamen`
			})
		],
	}),
	// Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
	// 	caseId: 2,
	// 	taskNumber: 2,
	// }),
	Object.assign({}, taskTemplates.spotErrorsTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 3,
		title: 'Opgave 2',
		taskId: 'subjects-spot-errors-hf-teaching',
		layout: 'subjects-spot-errors-hf-teaching',
		text: `Hvilke fejl kan I finde i denne HF-undervisning? Tryk på fejlene. Tryk OK, når I tror, I har dem alle.`,
		hintText: 'Det kender I nok fra undervisningen.',
		popupText: `Navnet afspejler, at uddannelsen er en forberedelse til videre studier efter folkeskolen.`,
		errors: [
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'student-napping'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'reverse-sitting'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'music'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'phone'}),
			Object.assign({}, taskTemplates.spotErrorsTemplate.errorTemplate, {id: 'lamp'})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 4,
		subtype: 'images',
		title: 'Opgave 3',
		taskId: 'subject-mc-teaching-items',
		text: `Hvilke ting tror I, man bruger i undervisningen på HF?`,
		hintText: `Det kan I finde ud af ved at tænke på en almindelig skoledag.`,
		layout: 'teaching-items',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'computer', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'group-work', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'books', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'phone',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'helmet',
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 'brush',
			}),
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 1,
		title: 'Opgave 1',
		taskId: 'subjects-mc-deadline-subjects',
		text: `Hvornår skal man senest vælge fagpakke på HF?`,
		hintText: `Tjek fx info-siderne om HF på UddannelsesGuiden på nettet.`,
		popupText: `Fagpakkerne starter først lidt inde i forløbet, så du kan nå at danne dig et overblik over fagene, før du vælger retning.`,
		image: 'students-teacher-laptop',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Inden man starter'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Inden første semester'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Inden andet semester'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Inden tredje semester', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5, text: 'Inden fjerde semester'
			}),
		],
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 2,
		taskId: 'subjects-sort-true-or-false',
		title: 'Opgave 2A',
		text: `Hvilke udsagn tror I passer til fagpakkerne på HF? I kan også finde svarene på www.ug.dk`,
		hintText: `I kan nemt finde svaret her: 
			<br /><br />https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/hf-eksamen-hf`,
		popupText: `Fagpakkerne på HF er bygget, så de enten forbereder til korte videregående uddannelser eller giver ekstra undervisning, hvis man vælger en udvidet model.`,
		layout: 'halfdouble-height',
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'true', 
				title: `Passer til fagpakkerne`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'false', 
				title: `Passer ikke til fagpakkerne`
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1, text: `Fagpakker består af to fag`, categoryIds: ['true']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2, text: `Udvidede fagpakker indeholder ekstra undervisning`, categoryIds: ['true']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3, text: `Fagpakker uden overbygning er målrettet erhvervsakademi- eller professionsbacheloruddannelser`, categoryIds: ['true'], layout: 'item-double'
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 4, text: `Fagpakker består af tre fag`, categoryIds: ['false']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 5, text: `Fag i fagpakkerne skal være A-niveau fag`, categoryIds: ['false']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 6, text: `Alle fagpakker giver adgang til universitetsuddannelser`, categoryIds: ['false']
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 3,
		title: 'Opgave 2B',
		taskId: 'subjects-mc-extra-teaching',
		lockedById: 'subjects-sort-true-or-false',
		text: `Hvis man vælger en udvidet fagpakke på HF, hvor mange timers ekstra undervisning får man så gennem hele sin HF?`,
		hintText: `Søg på “udvidet fagpakke HF” og se svaret.`,
		popupText: `En udvidet fagpakke betyder, at du får markant mere undervisning – nok til at det kan mærkes i hverdagen, men stadig til at overskue over to år.`,
		image: 'stx-throwing-hats',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: '150'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: '200'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: '250', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: '300'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5, text: '350'
			}),
		],
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 1,
		taskId: 'subjects-order-levels',
		title: 'Opgave 1A',
		text: `Vi har snakket meget om fag og niveauer, men hvordan hænger det nu sammen. Sorter niveauerne fra højest til lavest:`,
		hintText: `Det kan googles på få sekunder.`,
		popupText: `Niveauerne er inddelt, så A er det mest krævende og giver adgang til flest videregående studier, mens B og C bruges til at bygge viden gradvist op.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'a', 
				text: `A`,
				correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'b', 
				text: `B`,
				correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'c', 
				text: `C`,
				correctOrderNumbers: [3]
			})
		]
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 2,
		taskId: 'subjects-sort-levels',
		lockedById: 'subjects-order-levels',
		title: 'Opgave 1B',
		text: `Dansk er det eneste fag, man SKAL have på A-niveau på HF - men hvad tror I egentligt man lærer i dansk?`,
		hintText: `Hvis det lyder som naturfag eller økonomi, så passer det ikke.`,
		popupText: `Dansk på HF handler om sprog, tekster og kommunikation – ikke om tekniske eller naturvidenskabelige opgaver, som hører til i andre fag.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'danish', 
				title: `Hvad man lærer om i dansk på HF`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'other', 
				title: `Hvad man ikke lærer om i dansk på HF`
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1, text: `At analysere litteratur`, categoryIds: ['danish']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2, text: `At skrive essays`, categoryIds: ['danish']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3, text: `At diskutere sprogets udvikling`, categoryIds: ['danish']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 4, text: `At lave mundtlig præsentation`, categoryIds: ['danish']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 5, text: `At anvende tekniske tegninger`, categoryIds: ['other']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 6, text: `At udføre naturvidenskabelige eksperimenter`, categoryIds: ['other'], layout: 'item-halfdouble'
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 7, text: `At fortolke økonomiske modeller`, categoryIds: ['other']
			})
		]
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 3,
		taskId: 'subjects-order-events',
		title: 'Opgave 2',
		text: `Hvordan tror I at de vigtigste begivenheder i HF hænger sammen? Sæt dem i den rigtige rækkefølge fra første til sidste.`,
		hintText: `Tænk på, hvordan et skoleår typisk afsluttes.`,
		popupText: `Forløbet på HF er bygget op i en klar rytme: man begynder, vælger retning undervejs, og hele vejen igennem ligger eksamenerne som vigtige milepæle, før man til sidst afslutter med huen.`,
		image: 'hf-graduation',
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'a', 
				text: `Første skoledag`,
				correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'b', 
				text: `Afslutning af 1. semester`,
				correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'c', 
				text: `Valg af fagpakke`,
				correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'd', 
				text: `Første eksamen`,
				correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'e', 
				text: `Sidste skoledag`,
				correctOrderNumbers: [5]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'f', 
				text: `Sidste eksamen`,
				correctOrderNumbers: [6]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'g', 
				text: `Modtagelse af hue og eksamensbevis`,
				correctOrderNumbers: [7]
			})
		]
	}),


];

let taskIdsArr = [];
tasksData.forEach((task, index) => {
	/* Assign unique id used for navigation */
	task.id = 'stxhf-subjects-' + (index + 1 < 10 ? '0' : '') + (index + 1);

	/* Check taskId is set when required and unique */
	if (task.taskId) {
		if (taskIdsArr.indexOf(task.taskId) >= 0) {
			console.error('Task id not unique: ', task.taskId);
		} else {
			taskIdsArr.push(task.taskId);
		}
	} else {
		console.error('Missing task id for task: ', task);
	}
});

export {
	tasksData
};